import React from "react";

function MainImg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 330 315"
        >
            <g clipPath="url(#clip0_0_34175)">
                <g fill="#91B3FA" opacity="0.3">
                    <path d="M103.748 99.792a1.67 1.67 0 01-2.097-.764 65.898 65.898 0 01-2.451-5.13 1.669 1.669 0 01.88-2.189c.012-.004.02-.008.032-.011a1.67 1.67 0 012.161.894 65.4 65.4 0 002.328 4.877c.432.811.123 1.82-.694 2.252-.052.028-.107.051-.159.075v-.004zm-5.341-13.51a1.67 1.67 0 01-2.237-1.108 68.6 68.6 0 01-1.26-5.541 1.666 1.666 0 011.344-1.94 1.67 1.67 0 011.943 1.342c.32 1.761.725 3.53 1.197 5.264.226.824-.21 1.67-.983 1.984h-.004zm-2.229-14.348a1.67 1.67 0 01-2.292-1.48c-.08-1.885-.075-3.8.008-5.685.044-.918.821-1.63 1.745-1.59.92.039 1.634.818 1.594 1.74a62.88 62.88 0 00-.008 5.4 1.667 1.667 0 01-1.043 1.615h-.004zm1.04-14.487a1.671 1.671 0 01-2.265-1.853 68 68 0 011.28-5.542 1.675 1.675 0 012.055-1.163 1.668 1.668 0 011.166 2.05c-.48 1.726-.889 3.5-1.218 5.265a1.672 1.672 0 01-1.019 1.242zm4.25-13.894c-.4.162-.86.17-1.289-.016a1.662 1.662 0 01-.868-2.193 67.48 67.48 0 012.478-5.118 1.671 1.671 0 012.261-.68 1.664 1.664 0 01.682 2.255 62.944 62.944 0 00-2.356 4.861 1.66 1.66 0 01-.908.883v.008zm7.221-12.607a1.668 1.668 0 01-1.975-2.53 66.314 66.314 0 013.553-4.44 1.669 1.669 0 012.519 2.188 64.978 64.978 0 00-3.375 4.22c-.19.261-.444.451-.722.562zM163.96 4.413c-.214.088-.448.131-.694.12a61.621 61.621 0 00-5.409 0 1.669 1.669 0 11-.143-3.333 65.147 65.147 0 015.699 0c.92.039 1.637.819 1.598 1.737a1.671 1.671 0 01-1.043 1.476h-.008zm-45.432 15.845a1.674 1.674 0 01-1.884-.45 1.66 1.66 0 01.167-2.352 65.57 65.57 0 014.453-3.539 1.668 1.668 0 111.967 2.696 61.702 61.702 0 00-4.228 3.36 1.657 1.657 0 01-.471.29l-.004-.005zm30.918-14.831c-.103.04-.21.075-.321.095a63.49 63.49 0 00-5.274 1.207 1.668 1.668 0 11-.884-3.218 68.319 68.319 0 015.551-1.27 1.67 1.67 0 011.947 1.337 1.665 1.665 0 01-1.015 1.849h-.004zm-18.939 6.602a1.668 1.668 0 01-1.408-3.02 67.19 67.19 0 015.136-2.458c.012-.004.024-.008.031-.016a1.677 1.677 0 012.162.89 1.666 1.666 0 01-.881 2.19 62.67 62.67 0 00-4.877 2.335 2.958 2.958 0 01-.163.075v.004zM175.583 5.973a1.666 1.666 0 01-.996.08c-.84-.19-1.697-.369-2.55-.527a1.663 1.663 0 01-1.336-1.944 1.666 1.666 0 011.947-1.334 67.33 67.33 0 012.681.554 1.667 1.667 0 01.254 3.17z"></path>
                </g>
                <g fill="#91B3FA" opacity="0.3">
                    <path d="M216.863 35.731c-.749.301-1.626.024-2.054-.684a63.333 63.333 0 00-1.388-2.197 1.672 1.672 0 012.788-1.84c.503.76.995 1.539 1.463 2.31a1.666 1.666 0 01-.805 2.407l-.004.004zM185.568 129.472c-.714.288-1.432.562-2.162.827a1.668 1.668 0 11-1.146-3.131 65.299 65.299 0 004.925-2.023 1.673 1.673 0 012.217.816c.389.835.02 1.828-.817 2.212-.987.455-2.002.891-3.017 1.302v-.003zm-10.632 3.273a1.542 1.542 0 01-.273.083c-1.821.396-3.68.717-5.524.958a1.667 1.667 0 11-.433-3.305 63.794 63.794 0 005.247-.911c.9-.193 1.792.377 1.986 1.275a1.665 1.665 0 01-1.007 1.9h.004zm21.354-8.795a1.668 1.668 0 01-1.523-2.953 61.943 61.943 0 004.354-3.052 1.675 1.675 0 012.344.309 1.665 1.665 0 01-.309 2.339 66.564 66.564 0 01-4.588 3.214 2.032 2.032 0 01-.278.143zm-35.602 10.275c-.198.08-.412.123-.638.119a66.306 66.306 0 01-5.599-.277 1.668 1.668 0 11.305-3.321c1.761.162 3.549.249 5.318.261a1.668 1.668 0 01.61 3.214l.004.004zm46.721-19.261a1.67 1.67 0 01-1.816-2.719 63.722 63.722 0 003.577-3.93 1.67 1.67 0 012.566 2.133 66.646 66.646 0 01-3.768 4.14 1.667 1.667 0 01-.563.376h.004zm8.879-11.205a1.666 1.666 0 01-2.042-2.427 63.2 63.2 0 002.633-4.62 1.67 1.67 0 012.248-.72 1.667 1.667 0 01.722 2.245 68.097 68.097 0 01-2.772 4.861 1.662 1.662 0 01-.789.661zm6.218-12.873a1.662 1.662 0 01-1.182.024 1.668 1.668 0 01-1.019-2.126 63.564 63.564 0 001.562-5.082 1.67 1.67 0 013.232.843 67.344 67.344 0 01-1.645 5.348c-.167.47-.524.819-.952.99l.004.003zm3.259-13.917a1.632 1.632 0 01-.82.107 1.667 1.667 0 01-1.46-1.853c.21-1.753.349-3.534.409-5.296a1.668 1.668 0 013.335.119 65.865 65.865 0 01-.433 5.577 1.67 1.67 0 01-1.035 1.35l.004-.004zm.119-14.297a1.669 1.669 0 01-2.284-1.377 63.706 63.706 0 00-.769-5.257 1.669 1.669 0 013.279-.622c.345 1.825.619 3.69.809 5.534a1.663 1.663 0 01-1.035 1.718v.004zm-3.029-13.965a1.669 1.669 0 01-2.209-1.017 63.074 63.074 0 00-1.356-3.67 82.352 82.352 0 00-.539-1.298 1.662 1.662 0 01.876-2.19c.852-.383 1.828.029 2.193.876a67.42 67.42 0 011.994 5.225 1.669 1.669 0 01-.955 2.074h-.004zM146.432 132.531a1.68 1.68 0 01-1.003.079 64.877 64.877 0 01-2.653-.676 1.668 1.668 0 11.893-3.211c.836.23 1.685.448 2.522.642a1.667 1.667 0 01.241 3.17v-.004z"></path>
                </g>
                <path
                    fill="#91B3FA"
                    d="M141.273 113.757a.782.782 0 00.901-.107l7.042-6.365a41.547 41.547 0 0013.328 1.477l5.472 7.742a.784.784 0 00.857.301l10.945-3.171a.775.775 0 00.563-.708l.472-9.465a41.493 41.493 0 0010.464-8.367l9.363 1.61a.788.788 0 00.817-.391l5.492-9.967a.77.77 0 00-.107-.899l-6.377-7.03a41.204 41.204 0 001.48-13.303l7.756-5.463a.778.778 0 00.301-.855l-3.176-10.925a.775.775 0 00-.71-.562l-9.481-.47a41.471 41.471 0 00-8.383-10.447l1.614-9.345a.785.785 0 00-.393-.816l-9.985-5.482a.774.774 0 00-.9.107l-7.043 6.365a41.43 41.43 0 00-13.328-1.476l-5.472-7.743a.782.782 0 00-.856-.3l-10.945 3.17a.775.775 0 00-.563.709l-.472 9.464a41.51 41.51 0 00-10.465 8.367l-9.362-1.61a.787.787 0 00-.817.391l-5.492 9.967a.776.776 0 00.107.899l6.376 7.03a41.231 41.231 0 00-1.479 13.304l-7.756 5.462a.78.78 0 00-.302.855l3.177 10.925c.091.32.376.546.709.562l9.482.47a41.427 41.427 0 008.383 10.447l-1.614 9.345a.785.785 0 00.392.816l9.985 5.482z"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M164.678 77.86c-5.179 2.085-11.258.118-14.165-4.83-3.192-5.442-1.352-12.46 4.096-15.643a11.4 11.4 0 018.685-1.195 11.369 11.369 0 016.987 5.284c3.192 5.443 1.352 12.46-4.097 15.643a11.07 11.07 0 01-1.51.74h.004zm-7.547-18.747a9.11 9.11 0 00-1.169.574c-4.18 2.442-5.588 7.826-3.141 11.993 2.447 4.173 7.84 5.582 12.015 3.135 4.18-2.442 5.588-7.825 3.141-11.993a8.729 8.729 0 00-5.357-4.053 8.71 8.71 0 00-5.489.344z"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M171.082 93.087a29.768 29.768 0 01-3.621 1.187c-1.463.372-2.95.63-4.445.764-.02 0-.04 0-.059.004-.06.004-.115.012-.175.016-.111.008-.226.016-.337.028a.67.67 0 01-.714-.618.669.669 0 01.619-.712 27.258 27.258 0 005.623-1.002c9.132-2.644 15.782-9.737 18.273-18.232a26.6 26.6 0 00.016-14.954 27.34 27.34 0 00-.901-2.604c-2.304-5.7-6.467-10.395-11.932-13.395-6.277-3.448-13.526-4.248-20.41-2.256-14.212 4.12-22.413 19.003-18.289 33.186a26.767 26.767 0 007.491 12.152c.076.067.131.15.167.237a.666.666 0 01-.131.705.67.67 0 01-.944.035 28.065 28.065 0 01-7.867-12.753c-4.331-14.891 4.286-30.519 19.2-34.837 7.225-2.094 14.835-1.25 21.426 2.367 5.738 3.15 10.108 8.079 12.527 14.064.36.89.674 1.8.947 2.735 2.098 7.212 1.253 14.808-2.371 21.387-3.156 5.731-8.097 10.09-14.093 12.504v-.008z"
                ></path>
                <g fill="#91B3FA" opacity="0.3">
                    <path d="M67.357 161.818a1.029 1.029 0 01-1.193-.316 43.309 43.309 0 01-1.575-2.114 1.028 1.028 0 01.258-1.433 1.028 1.028 0 011.436.257 41.27 41.27 0 001.499 2.015 1.026 1.026 0 01-.425 1.591zM63.031 155.18a1.03 1.03 0 01-1.297-.475 46.018 46.018 0 01-2.26-4.995c-.202-.534.103-1.116.599-1.33a1.031 1.031 0 011.328.598 43.259 43.259 0 002.153 4.765 1.028 1.028 0 01-.527 1.433l.004.004zm-3.795-9.998a1.034 1.034 0 01-1.392-.709 44.67 44.67 0 01-.98-5.391 1.032 1.032 0 012.05-.241c.203 1.721.52 3.455.933 5.145a1.032 1.032 0 01-.615 1.2l.004-.004zm-1.253-10.616a1.025 1.025 0 01-1.416-.962 43.58 43.58 0 01.381-5.471 1.032 1.032 0 012.046.27 42.52 42.52 0 00-.36 5.217c0 .431-.27.795-.647.946h-.004zm1.4-10.601a1.029 1.029 0 01-1.384-1.211 44.212 44.212 0 011.709-5.209 1.04 1.04 0 011.34-.578c.532.21.79.808.58 1.338a42.509 42.509 0 00-1.63 4.968 1.034 1.034 0 01-.615.696v-.004zm3.95-9.939a1.03 1.03 0 01-1.29-1.449 45.48 45.48 0 012.923-4.639 1.03 1.03 0 011.677 1.2 41.91 41.91 0 00-2.787 4.425 1.006 1.006 0 01-.52.459l-.004.004zm6.245-8.676a1.042 1.042 0 01-1.087-.198 1.03 1.03 0 01-.055-1.457 44.254 44.254 0 013.97-3.784 1.04 1.04 0 011.455.123 1.023 1.023 0 01-.123 1.448 42.318 42.318 0 00-3.783 3.61 1.042 1.042 0 01-.373.258h-.004zm8.18-6.888a1.034 1.034 0 01-1.248-.392 1.032 1.032 0 01.301-1.425c1.527-.99 3.133-1.9 4.778-2.7a1.04 1.04 0 011.38.476 1.03 1.03 0 01-.475 1.377 42.515 42.515 0 00-4.56 2.573.943.943 0 01-.18.091h.005zm14.804-6.1a.88.88 0 01-.175.052 42.737 42.737 0 00-5.048 1.39 1.032 1.032 0 01-1.312-.638c-.187-.538.099-1.14.638-1.31a45.21 45.21 0 015.294-1.46 1.027 1.027 0 011.221.795c.103.495-.166.981-.622 1.168l.004.003z"></path>
                </g>
                <g fill="#91B3FA" opacity="0.3">
                    <path d="M118.353 174.932a1.029 1.029 0 01-.781-1.904 43.119 43.119 0 004.624-2.268 1.039 1.039 0 011.407.384 1.032 1.032 0 01-.384 1.405 45.207 45.207 0 01-4.846 2.379c-.004 0-.008 0-.012.004h-.008zm-4.981 1.738c-.035.016-.071.024-.107.036-1.729.49-3.501.878-5.274 1.159a1.027 1.027 0 01-1.177-.855 1.031 1.031 0 01.856-1.179 42.899 42.899 0 005.036-1.105 1.032 1.032 0 011.273.709 1.026 1.026 0 01-.607 1.235zm14.133-6.943c-.424.17-.928.044-1.213-.34a1.029 1.029 0 01.21-1.441 43.298 43.298 0 003.938-3.317 1.034 1.034 0 011.459.035 1.03 1.03 0 01-.036 1.457 44.154 44.154 0 01-4.128 3.475.927.927 0 01-.23.131zm-24.546 8.574a1.034 1.034 0 01-.353.075 44.647 44.647 0 01-5.4-.147 1.03 1.03 0 11.182-2.05c1.705.151 3.438.198 5.151.143a1.031 1.031 0 011.067.993c.015.443-.254.831-.647.99v-.004zm32.164-15.829a1.045 1.045 0 01-1.043-.159 1.029 1.029 0 01-.143-1.448 42.717 42.717 0 003.022-4.165 1.03 1.03 0 011.741 1.105 45.03 45.03 0 01-3.169 4.366 1.057 1.057 0 01-.412.301h.004zm5.655-8.871a1.052 1.052 0 01-.833-.024 1.028 1.028 0 01-.488-1.373 43.689 43.689 0 001.939-4.766c.183-.538.77-.827 1.309-.645.539.182.829.764.646 1.302a44.955 44.955 0 01-2.03 4.995c-.115.242-.313.42-.543.511zm3.362-9.967a1.013 1.013 0 01-.594.052 1.029 1.029 0 01-.801-1.216c.349-1.678.594-3.388.733-5.09.048-.566.544-.99 1.115-.942.567.047.991.542.943 1.112a44.106 44.106 0 01-.769 5.34 1.03 1.03 0 01-.627.748v-.004zM92.415 177.363a1.034 1.034 0 01-.603.051 44.378 44.378 0 01-2.561-.629 1.029 1.029 0 11.55-1.983c.798.221 1.619.423 2.444.597.555.119.912.669.793 1.224a1.039 1.039 0 01-.623.74z"></path>
                </g>
                <path
                    fill="#91B3FA"
                    d="M88.228 164.708a.523.523 0 00.602-.071l4.711-4.26a27.75 27.75 0 008.919.99l3.664 5.181a.521.521 0 00.571.202l7.324-2.121a.527.527 0 00.377-.475l.313-6.334a27.682 27.682 0 007.003-5.601l6.265 1.081c.218.04.44-.067.547-.261l3.676-6.67a.52.52 0 00-.071-.602l-4.267-4.702a27.622 27.622 0 00.992-8.902l5.19-3.658a.522.522 0 00.203-.57l-2.126-7.311a.527.527 0 00-.476-.376l-6.344-.312a27.659 27.659 0 00-5.612-6.991l1.083-6.254a.52.52 0 00-.262-.546l-6.682-3.669a.522.522 0 00-.602.071l-4.711 4.259a27.748 27.748 0 00-8.918-.989l-3.665-5.182a.525.525 0 00-.57-.202l-7.325 2.122a.525.525 0 00-.377.475l-.313 6.333a27.677 27.677 0 00-7.003 5.601l-6.265-1.08a.522.522 0 00-.547.261l-3.676 6.669a.521.521 0 00.07.602l4.268 4.703a27.6 27.6 0 00-.992 8.902l-5.19 3.657a.523.523 0 00-.203.57l2.126 7.311a.526.526 0 00.476.376l6.344.313a27.657 27.657 0 005.612 6.99l-1.083 6.254c-.04.218.067.44.262.547l6.681 3.669z"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M103.927 140.82a7.76 7.76 0 01-4.878.304 7.743 7.743 0 01-4.758-3.602c-2.173-3.705-.924-8.486 2.791-10.655 3.72-2.166 8.502-.919 10.675 2.786a7.715 7.715 0 01.817 5.906 7.721 7.721 0 01-3.608 4.75 7.692 7.692 0 01-1.039.511zm-5.048-12.544a5.724 5.724 0 00.694 10.857 5.72 5.72 0 004.354-.597 5.691 5.691 0 002.653-3.496 5.695 5.695 0 00-.599-4.346c-1.456-2.478-4.501-3.463-7.098-2.418h-.004z"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M108.372 151.424a19.673 19.673 0 01-5.762 1.358l-.178.011a1.037 1.037 0 01-1.103-.953 1.035 1.035 0 01.956-1.101 17.526 17.526 0 003.835-.708 17.164 17.164 0 007.292-4.37 17.484 17.484 0 002.812-3.729c.008-.012.012-.024.019-.032.02-.035.04-.067.056-.103a17.197 17.197 0 001.463-13.189 17.221 17.221 0 00-8.307-10.358 17.283 17.283 0 00-13.213-1.461 17.252 17.252 0 00-10.378 8.293 17.195 17.195 0 00-1.463 13.189 17.256 17.256 0 004.846 7.861 1.028 1.028 0 01.052 1.452 1.034 1.034 0 01-1.46.056 19.364 19.364 0 01-5.429-8.796 19.237 19.237 0 011.638-14.756 19.277 19.277 0 0111.61-9.278 19.332 19.332 0 0114.784 1.635c3.957 2.173 6.975 5.573 8.641 9.701.246.614.468 1.243.654 1.884 2.8 9.635-2.252 19.717-11.377 23.39l.012.004z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M62.135 25.915H50.778v257.217h11.357V25.915z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M81.918 0H30.701C18.016 0 7.733 10.264 7.733 22.926v51.126c0 12.661 10.283 22.926 22.968 22.926h51.217c12.685 0 22.968-10.265 22.968-22.926V22.926C104.886 10.265 94.603 0 81.918 0z"
                ></path>
                <path
                    fill="#fff"
                    d="M79.321 4.75H33.694c-11.272 0-20.41 9.121-20.41 20.373v45.544c0 11.252 9.138 20.373 20.41 20.373h45.627c11.272 0 20.41-9.12 20.41-20.373V25.123c0-11.252-9.138-20.373-20.41-20.373z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M38.362 22.59l-5.679-2.775a1.41 1.41 0 00-1.562.218l-.619.554-.999.898-.638.575c-.429.383-.58.989-.381 1.527l2.173 5.926c.33.898 1.079 1.583 2.018 1.781l3.839.84L61.429 59.75l1.435-1.29 1-.899 1.356-1.219-24.915-27.617-.404-3.923a2.791 2.791 0 00-1.535-2.216l-.004.004z"
                ></path>
                <path
                    fill="url(#paint0_linear_0_34175)"
                    d="M37.977 22.926l-5.147-2.533c-.464-.226-1.055-.186-1.44.162l-.555.499-.9.808-.575.518c-.384.344-.487.926-.309 1.413l1.97 5.356a2.53 2.53 0 001.833 1.607l3.474.756 22.468 24.901 1.277-1.148.9-.807 1.404-1.263-22.469-24.901-.456-3.452c-.09-.859-.697-1.532-1.475-1.912v-.004z"
                ></path>
                <path
                    fill="url(#paint1_linear_0_34175)"
                    d="M81.796 65.676L64.082 49.894l-8.946 8.071 13.629 18.798a11.935 11.935 0 005.064 4.006l5.433 2.311c.92.385 2.042.274 2.783-.391l3.72-3.345c.674-.606.916-1.587.742-2.474l-.916-4.552a12.046 12.046 0 00-3.8-6.642h.005z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M62.773 48.65l-8.96 8.055a1.47 1.47 0 00-.11 2.08l.112.123a1.477 1.477 0 002.084.109l8.96-8.056a1.47 1.47 0 00.109-2.08l-.112-.123a1.477 1.477 0 00-2.083-.109zM78.278 77.151a1.253 1.253 0 01-.095 1.777l-.02.016a1.258 1.258 0 01-1.78-.095L59.498 60.134a1.253 1.253 0 01.095-1.777l.02-.016a1.259 1.259 0 011.78.095l16.885 18.715zM64.013 54.39l.017-.016a1.263 1.263 0 011.781.093l16.884 18.717a1.258 1.258 0 01-.094 1.778l-.017.016a1.263 1.263 0 01-1.781-.093L63.919 56.167a1.258 1.258 0 01.094-1.777zM26.299 64.765l-1.194 1.113c-2.05 1.908-2.668 4.572-1.38 5.953l1.531 1.643c1.289 1.381 3.997.954 6.047-.954l1.194-1.113c.08-.075.159-.15.234-.225l34.004-34.493-3.34-3.574-36.854 31.437a6.25 6.25 0 00-.242.217v-.004zm1.646 1.576c1.542-1.437 3.49-1.86 4.342-.942.856.914.297 2.822-1.25 4.259-1.542 1.437-3.489 1.86-4.341.942-.857-.914-.298-2.822 1.249-4.26z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M73.825 20.045l-6.936 6.452a2.174 2.174 0 00-.682 1.793l.325 3.44a2.174 2.174 0 001.809 1.94l3.414.565a2.18 2.18 0 001.84-.554l6.936-6.452c1.046-.974 2.775-.273 2.815 1.152.091 3.412-1.265 6.9-4.025 9.464-4.989 4.64-12.043 3.95-16.512-.839-4.47-4.79-4.663-11.863.321-16.502 2.76-2.569 6.337-3.673 9.743-3.34 1.424.138 1.999 1.907.956 2.88h-.004z"
                ></path>
                <path
                    fill="url(#paint2_linear_0_34175)"
                    d="M74.432 20.698l-6.936 6.452a2.162 2.162 0 00-.682 1.793l.325 3.44a2.174 2.174 0 001.808 1.94l3.415.565a2.18 2.18 0 001.84-.554l6.935-6.452c1.047-.974 2.776-.273 2.816 1.152.09 3.412-1.265 6.9-4.025 9.464-4.989 4.64-12.043 3.95-16.512-.839-4.47-4.79-4.664-11.863.32-16.502 2.76-2.569 6.338-3.673 9.744-3.34 1.423.138 1.998 1.907.956 2.88h-.004z"
                ></path>
                <path
                    fill="url(#paint3_linear_0_34175)"
                    d="M26.787 65.288L25.593 66.4c-2.05 1.908-2.669 4.572-1.38 5.953l1.53 1.643c1.29 1.382 3.998.954 6.048-.954l1.194-1.112c.079-.075.158-.15.234-.226l34.003-34.488-3.338-3.575-36.855 31.437c-.084.071-.163.142-.242.214v-.004zm1.645 1.575c1.543-1.437 3.49-1.86 4.343-.942.856.914.297 2.822-1.25 4.26-1.542 1.436-3.49 1.86-4.342.941-.856-.914-.297-2.822 1.25-4.259z"
                ></path>
                <path
                    fill="url(#paint4_linear_0_34175)"
                    d="M183.244 184.096c37.192 9.282 59.014 34.1 69.776 36.606 10.758 2.509 53.863 4.805 60.89 11.32 7.026 6.52.313 11.151 9.35 19.531 9.997 28.159-20.957 36.586-20.957 36.586l-281.385-2.28S1.93 287.565 1.51 274.028c-.42-13.538-.718-19.617.281-31.809.996-12.192 5.929-13.561 8.65-19.882 2.72-6.322 29.133-7.007 34.276-14.04 5.14-7.03 11.262-18.244 33.072-22.068 30.126-5.28 83.882-7.521 105.458-2.133h-.004z"
                ></path>
                <path
                    fill="url(#paint5_linear_0_34175)"
                    d="M0 273.228c.484 15.56 26.914 12.801 27.029 12.793 0 0 21.012-16.054-7.896-15.437-8.684-.226-17.491-4.817-17.491-4.817L0 273.228z"
                ></path>
                <path
                    fill="url(#paint6_linear_0_34175)"
                    d="M324.973 258.511s.278 3.97-7.173 8.024c-9.232 5.023-47.098-.772-47.098-.772l2.149 20.86 30.213 1.54c-.706.194 39.675-2.13 21.905-29.652h.004z"
                ></path>
                <path
                    fill="url(#paint7_linear_0_34175)"
                    d="M49.477 228.678s-.908-7.066 6.527-15.727c7.435-8.66 11.778-14.376 17.496-15.845 5.718-1.472 47.569-7.251 50.317-2.806 2.749 4.445 6.29 31.741 6.29 31.741l-80.63 2.637z"
                ></path>
                <path
                    fill="url(#paint8_linear_0_34175)"
                    d="M74.261 196.354c4.687-.696 40.285-4.829 49.477-3.649l2.379 9.132-76.676 26.833s-.364-5.815 3.466-11.547c6.436-9.63 16.453-20.155 21.354-20.769z"
                    opacity="0.42"
                ></path>
                <path
                    fill="url(#paint9_linear_0_34175)"
                    d="M136.336 194.292c1.158 5.277 5.429 30.993 5.429 30.993l90.496-.419s-28.528-26.168-50.457-30.309c-21.929-4.14-46.209-3.055-45.472-.265h.004z"
                ></path>
                <path
                    fill="url(#paint10_linear_0_34175)"
                    d="M178.715 192.618c-17.864-2.474-24.411-2.007-43.136-.368l1.804 7.477s27.869-5.455 53.835-2.3c0 0-6.67-3.998-12.499-4.805l-.004-.004z"
                    opacity="0.42"
                ></path>
                <path
                    fill="url(#paint11_linear_0_34175)"
                    d="M311.824 230.681s-14.66-4.691-18.237 6.879c-3.411 11.032 29.673 13.997 29.673 13.997s-2.439-16.364-11.436-20.876z"
                ></path>
                <path
                    fill="#fff"
                    d="M44.469 216.178a.871.871 0 00.245-.036c3.443-1.037 6.345-4.659 9.7-8.851 4.905-6.119 10.46-13.058 19.526-14.788 17.385-3.313 43.735-5.605 43.997-5.629a.845.845 0 00.773-.918.835.835 0 00-.92-.772c-.266.024-26.704 2.324-44.171 5.653-9.684 1.844-15.7 9.357-20.537 15.393-3.18 3.971-5.929 7.398-8.863 8.285a.846.846 0 00-.567 1.061.85.85 0 00.813.606l.004-.004zM17.523 225.808a.849.849 0 00.762-.471c1.427-2.874 7.752-4.176 13.867-5.435 2.189-.451 4.45-.914 6.527-1.46a.847.847 0 00.607-1.037.852.852 0 00-1.04-.606c-2.037.534-4.274.993-6.439 1.441-6.813 1.405-13.249 2.731-15.045 6.345a.851.851 0 00.761 1.227v-.004zM141.86 284.204h.084c.495 0 .888-.439.884-.934a.908.908 0 00-.528-.815c-1.76-2.83-4.048-33.424-5.087-52.281a.896.896 0 00-1.789.091c.008.135.746 13.458 1.801 26.584 2.149 26.71 3.473 27.355 4.631 27.355h.004z"
                    opacity="0.56"
                ></path>
                <path
                    fill="url(#paint12_linear_0_34175)"
                    d="M111.275 285.788c.202-1.188.317-2.898.317-4.445 0-18.529-15.049-33.491-33.611-33.491-18.563 0-33.611 14.934-33.611 33.463 0 1.548.114 3.285.317 4.473H111.275z"
                ></path>
                <path
                    fill="url(#paint13_linear_0_34175)"
                    d="M104.911 283.888c1.849-14.989-8.825-28.635-23.84-30.481-15.016-1.846-28.687 8.809-30.536 23.797-1.849 14.988 8.825 28.635 23.84 30.481 15.016 1.845 28.687-8.809 30.536-23.797z"
                ></path>
                <path
                    fill="url(#paint14_linear_0_34175)"
                    d="M77.72 302.741c12.285 0 22.245-9.942 22.245-22.206s-9.96-22.206-22.246-22.206c-12.286 0-22.246 9.942-22.246 22.206s9.96 22.206 22.246 22.206z"
                    opacity="0.6"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M96.404 288.582a.393.393 0 01-.365-.55 19.088 19.088 0 001.515-7.497c0-10.624-8.656-19.265-19.3-19.265-3.303 0-6.559.847-9.422 2.446a.395.395 0 11-.388-.688 20.142 20.142 0 019.81-2.549c11.08 0 20.093 8.997 20.093 20.056 0 2.708-.531 5.336-1.578 7.806a.396.396 0 01-.365.241z"
                ></path>
                <path
                    fill="url(#paint15_linear_0_34175)"
                    d="M276.218 286.975c.202-1.187.317-2.822.317-4.37 0-18.528-15.049-33.451-33.611-33.451-18.562 0-33.611 14.875-33.611 33.404 0 1.547.115 3.23.317 4.417H276.218z"
                ></path>
                <path
                    fill="url(#paint16_linear_0_34175)"
                    d="M242.666 309.217c15.129 0 27.394-12.242 27.394-27.344 0-15.101-12.265-27.344-27.394-27.344-15.129 0-27.393 12.243-27.393 27.344 0 15.102 12.264 27.344 27.393 27.344z"
                ></path>
                <path
                    fill="url(#paint17_linear_0_34175)"
                    d="M246.239 303.78c12.128-1.965 20.363-13.371 18.395-25.477-1.969-12.105-13.396-20.326-25.523-18.361-12.128 1.965-20.363 13.371-18.395 25.477 1.969 12.106 13.396 20.326 25.523 18.361z"
                    opacity="0.6"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M261.351 289.924a.392.392 0 01-.364-.55 19.091 19.091 0 001.514-7.497c0-10.624-8.656-19.265-19.299-19.265-3.304 0-6.559.847-9.422 2.446a.395.395 0 11-.389-.688 20.144 20.144 0 019.811-2.549c11.079 0 20.093 8.997 20.093 20.056 0 2.708-.532 5.336-1.579 7.806a.396.396 0 01-.365.241z"
                ></path>
                <path
                    fill="url(#paint18_linear_0_34175)"
                    d="M217.442 222.962l-6.868-7.188c-2.863-2.997-6.464-5.039-10.378-5.89l-13.586-2.949c-3.727-.812-7.296 2.003-7.704 6.076l-.096.958c-.416 4.148 2.626 7.754 6.5 7.707l17.503-.214c2.443-.032 4.66 1.524 5.623 3.938l.322.808c.428 1.072 1.407 1.765 2.49 1.765h4.302c2.435 0 3.637-3.186 1.888-5.015l.004.004z"
                ></path>
                <path
                    fill="url(#paint19_linear_0_34175)"
                    d="M146.595 231.168h22.698c1.769 0 3.018 1.896 2.403 3.681-1.039 3.024-3.513 6.883-9.39 7.334-5.286.404-11.952-2.818-16.98-5.882-2.28-1.389-1.352-5.137 1.269-5.137v.004z"
                ></path>
                <path
                    fill="url(#paint20_linear_0_34175)"
                    d="M1.697 242.219l3.97.705a2.76 2.76 0 012.28 2.719v9.349a2.76 2.76 0 01-2.76 2.755H1.233l.464-15.528z"
                ></path>
                <path
                    fill="url(#paint21_linear_0_34175)"
                    d="M193.046 164.181l4.295 5.879c7.384.49 13.356-.855 18.126-3.013-1.534-6.852-3.541-11.091-5.242-13.664-8.324 8.396-17.183 10.802-17.183 10.802l.004-.004z"
                ></path>
                <path
                    fill="url(#paint22_linear_0_34175)"
                    d="M231.781 151.139l-8.994-20.832c-2.538 10.509-7.447 17.919-12.558 23.072 1.701 2.573 3.703 6.813 5.242 13.664 11.908-5.391 16.314-15.904 16.314-15.904h-.004z"
                ></path>
                <path
                    fill="url(#paint23_linear_0_34175)"
                    d="M241.163 313.488c-6.107.281-12.015.103-15.961-.099 3.593-2.553 11.869-8.106 18.797-10.315l4.754-.285s1.61 2.446 2.185 8.043c-.789.982-3.089 2.351-9.775 2.656z"
                ></path>
                <path
                    fill="url(#paint24_linear_0_34175)"
                    d="M225.155 313.425l.047-.036c3.946.202 9.854.38 15.961.099 6.682-.309 8.986-1.674 9.775-2.656.028.257.056.515.075.784a2.219 2.219 0 01-2.046 2.398c-5 .377-17.396 1.232-23.376.919-.789-.04-1.083-1.053-.436-1.512v.004z"
                ></path>
                <path
                    fill="url(#paint25_linear_0_34175)"
                    d="M283.903 311.857c.448-2.862 1.166-6.998 1.717-8.055.868-1.658 3.843 0 3.843 0s2.089.974 3.049 2.593c.615 1.033 2.308 3.97 3.454 5.965.131.229.186.475.178.708l-11.912.416a2.374 2.374 0 01-.333-1.631l.004.004z"
                ></path>
                <path
                    fill="url(#paint26_linear_0_34175)"
                    d="M296.148 313.072a1.357 1.357 0 01-1.32 1.318l-8.486.234a2.397 2.397 0 01-2.106-1.132l11.912-.416v-.004z"
                ></path>
                <path
                    fill="url(#paint27_linear_0_34175)"
                    d="M213.524 127.841c7.598-1.987 21.608-5.099 32.763-4.434 2.561.155 4.615 2.174 4.758 4.731 1.686 29.651 3.989 55.966 8.324 71.276-9.747 3.852-19.407 5.637-28.94 4.24-7.142-15.267-13.384-32.898-18.721-52.915 0 0-3.129-15.967-.091-21.287.472-.832 1.098-1.402 1.907-1.611z"
                ></path>
                <path
                    fill="url(#paint28_linear_0_34175)"
                    d="M231.797 107.068s1.919 11.423 2.49 16.704a2.073 2.073 0 01-1.126 2.066c-2.098 1.076-6.571 2.81-11.448 1.219-.805-.261-1.329-1.037-1.313-1.88l.333-15.251 11.06-2.862.004.004z"
                ></path>
                <path
                    fill="url(#paint29_linear_0_34175)"
                    d="M219.286 94.413s-3.7 8.486-3.95 12.939c-.25 4.454-1.209 7.343 3.95 8.242 5.159.898 9.505-1.671 11.861-6.104 0 0 3.687-6.836 2.863-9.638-.825-2.803-14.724-5.44-14.724-5.44z"
                ></path>
                <path
                    fill="url(#paint30_linear_0_34175)"
                    d="M229.382 106.296h-.65s2.688-5.502.325-6.468c-2.36-.966-9.589-.954-11.607-4.267-1.947-3.195 3.192-5.154 5.789-6.31.163-.071-3.085-.495-3.001-.336l-.536-.396c.147.277 1.852-1.041 1.939-1.342.084-.285 2.106-1.52 2.261-1.267.618.99-1.975 2.273 2.514 3.096 6.364 1.171 10.576 3.744 10.679 8.138a.35.35 0 00.543.285c.472-.285-1.396-.42-.393.424.718.601 1.174 1.306 1.285 2.244.127 1.096-.69 2.442-1.455 3.163a2.11 2.11 0 00-.686 1.607c.012.637.385 1.152.46 1.765.099.788-.686 1.334-1.289 1.678a39.48 39.48 0 00-2.474 1.52c-.448.305-1.349 1.239-1.939 1.089a.35.35 0 01-.266-.36l.242-3.891a.35.35 0 00-.349-.372h-1.392z"
                ></path>
                <path
                    fill="url(#paint31_linear_0_34175)"
                    d="M229.223 107.111s1.412-5.419 3.847-3.899c2.435 1.52-1.265 6.072-3.22 6.278l-.627-2.375v-.004z"
                ></path>
                <path
                    fill="url(#paint32_linear_0_34175)"
                    d="M270.702 167.332c3.755 10.521 1.642 21.799 1.642 21.799l4.953 1.318s6.396-7.596 4.933-24.447c-4.573-.696-8.851.372-11.528 1.33z"
                ></path>
                <path
                    fill="url(#paint33_linear_0_34175)"
                    d="M282.23 166.002a65.801 65.801 0 00-.809-6.032c-3.347-18.588-27.219-32.885-32.834-36.016a.765.765 0 00-1.138.696l.797 25.266c13.296 1.785 19.585 9.377 22.456 17.412 2.673-.958 6.955-2.026 11.528-1.33v.004z"
                ></path>
                <path
                    fill="url(#paint34_linear_0_34175)"
                    d="M180.841 166.133a3.22 3.22 0 01-1.757-2.102c-.476-1.801-.88-4.627 1.059-5.149 2.887-.78 6.955 5.015 6.955 5.015l1.753 4.251 2.01 1.417c-2.089.222-5.797-1.322-10.02-3.432z"
                ></path>
                <path
                    fill="url(#paint35_linear_0_34175)"
                    d="M237.892 102.001a806.483 806.483 0 01-9.069-2.517c-5.151-1.465-10.386-2.76-15.469-4.438-1.083-.356-2.166-.7-3.256-1.021-.654-.194-1.471-.522-1.911-1.065-.48-.593-.278-1.492.551-1.52 1.423-.051 2.898.143 4.294.388.405.072 4.382.82 4.374.895 0-.008 1.515-10.438 13.34-6.805 14.248 4.382 8.914 17.029 7.146 16.087v-.004z"
                ></path>
                <path
                    fill="url(#paint36_linear_0_34175)"
                    d="M230.429 203.962c.293 1.536 10.695 66.519 11.325 100.145.012.562.397 1.037.92 1.116 1.321.198 3.89.451 6.385-.043a.786.786 0 00.618-.741c.365-6.266 3.288-59.247-.293-84.188 0 0 29.57 66.669 34.055 85.055.111.447.492.748.924.725 1.265-.072 3.902-.317 5.992-1.14.749-.297 1.178-1.14.987-1.972-2.506-11-20.057-86.801-31.973-103.501l-28.94 4.548v-.004z"
                ></path>
                <path
                    fill="url(#paint37_linear_0_34175)"
                    d="M249.388 219.218a.374.374 0 00.269-.111.386.386 0 00.008-.546l-3.961-4.042a.387.387 0 10-.555.538l3.961 4.042a.382.382 0 00.278.115v.004z"
                    opacity="0.25"
                ></path>
                <path
                    fill="url(#paint38_linear_0_34175)"
                    d="M230.853 204.655l-10.814-25.566-1.792-28.848 22.099-1.995c4.846 8.613 9.862 16.533 15.279 22.756.226.261.393.57.476.902l6.916 26.758-32.164 5.993z"
                ></path>
                <path
                    fill="url(#paint39_linear_0_34175)"
                    d="M218.247 150.236c-2.344-6.768-3.145-13.81-4.723-22.399 2.205-1.39 2.974-2.043 5.092-1.568 1.447 8.613 2.962 16.771 4.857 24.288l-5.23-.321h.004z"
                ></path>
                <path
                    fill="url(#paint40_linear_0_34175)"
                    d="M235.854 148.673c.031-8.348.138-16.803 1.879-25.361 2.748-.502 3.934-.716 5.817 0-2.105 9.116-2.133 18.074-3.2 26.24l-4.493-.883-.003.004z"
                ></path>
                <path
                    fill="url(#paint41_linear_0_34175)"
                    d="M301.692 206.04l4.406 2.676c7.558 4.588 11.174 12.433 8.073 17.52l-3.684 6.048c-3.101 5.086-11.737 5.49-19.299.902l-4.406-2.675a26.893 26.893 0 01-.865-.551l-127.16-84.901 8.026-13.177L300.8 205.526c.297.166.595.336.884.511l.008.003zm-4.076 5.914c-5.691-3.455-11.972-3.519-14.026-.142-2.058 3.376.888 8.914 6.578 12.365 5.691 3.456 11.972 3.519 14.026.143 2.058-3.377-.888-8.91-6.578-12.366z"
                ></path>
                <path
                    fill="url(#paint42_linear_0_34175)"
                    d="M126.209 98.15l25.557 15.516a6.848 6.848 0 013.256 5.102l1.197 10.834a6.854 6.854 0 01-4.354 7.145l-10.187 3.923a6.888 6.888 0 01-6.04-.539l-25.557-15.516c-3.854-2.34-8.752.922-7.959 5.355 1.896 10.608 8.328 20.512 18.495 26.687 18.38 11.158 39.742 4.528 50.493-13.122 10.75-17.646 6.824-39.63-11.556-50.788-10.167-6.175-21.937-7.315-32.247-4.117-4.31 1.338-4.961 7.176-1.102 9.52h.004z"
                ></path>
                <path
                    fill="url(#paint43_linear_0_34175)"
                    d="M124.745 100.552l25.558 15.517a6.845 6.845 0 013.255 5.102l1.198 10.834a6.853 6.853 0 01-4.354 7.144l-10.187 3.923a6.877 6.877 0 01-6.036-.538l-25.557-15.517c-3.855-2.339-8.752.923-7.959 5.356 1.896 10.608 8.328 20.512 18.495 26.687 18.38 11.158 39.742 4.528 50.492-13.122 10.751-17.646 6.825-39.63-11.555-50.789-10.168-6.175-21.937-7.315-32.247-4.116-4.311 1.338-4.961 7.176-1.103 9.519z"
                ></path>
                <path
                    fill="url(#paint44_linear_0_34175)"
                    d="M300.522 207.96l4.406 2.676c7.558 4.588 11.175 12.433 8.074 17.52l-3.684 6.048c-3.101 5.086-11.738 5.49-19.3.902l-4.406-2.676c-.293-.178-.579-.36-.864-.55l-127.161-84.901 8.026-13.177 134.017 73.644c.297.166.595.336.884.51l.008.004zm-4.076 5.914c-5.691-3.456-11.972-3.519-14.026-.142-2.058 3.376.888 8.914 6.579 12.365 5.69 3.456 11.971 3.519 14.025.143 2.058-3.377-.888-8.91-6.578-12.366z"
                ></path>
                <path
                    fill="url(#paint45_linear_0_34175)"
                    d="M272.673 186.661h-6.123s4.965 2.972 5.131 6.099c.167 3.127-1.97 9.603-2.97 11.365-1.094 1.927 13.864-2.87 8.582-17.464h-4.62z"
                ></path>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_0_34175"
                    x1="28.968"
                    x2="62.377"
                    y1="38.328"
                    y2="38.328"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear_0_34175"
                    x1="55.136"
                    x2="86.562"
                    y1="66.598"
                    y2="66.598"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint2_linear_0_34175"
                    x1="1061.44"
                    x2="997.464"
                    y1="-489.47"
                    y2="-455.77"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint3_linear_0_34175"
                    x1="1158.46"
                    x2="1078.24"
                    y1="-601.61"
                    y2="-565.314"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint4_linear_0_34175"
                    x1="195.029"
                    x2="175.273"
                    y1="-60.483"
                    y2="136.647"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint5_linear_0_34175"
                    x1="34.277"
                    x2="14.521"
                    y1="104.89"
                    y2="302.02"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint6_linear_0_34175"
                    x1="313.763"
                    x2="294.007"
                    y1="132.903"
                    y2="330.033"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint7_linear_0_34175"
                    x1="126.444"
                    x2="72.112"
                    y1="129.717"
                    y2="269.12"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint8_linear_0_34175"
                    x1="235.89"
                    x2="177.465"
                    y1="-283.381"
                    y2="-86.695"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint9_linear_0_34175"
                    x1="203.742"
                    x2="149.396"
                    y1="159.54"
                    y2="298.979"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint10_linear_0_34175"
                    x1="300.189"
                    x2="241.768"
                    y1="-264.278"
                    y2="-67.596"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint11_linear_0_34175"
                    x1="319.537"
                    x2="299.78"
                    y1="133.481"
                    y2="330.611"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint12_linear_0_34175"
                    x1="95.112"
                    x2="75.355"
                    y1="110.99"
                    y2="308.12"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint13_linear_0_34175"
                    x1="50.337"
                    x2="105.124"
                    y1="280.544"
                    y2="280.544"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint14_linear_0_34175"
                    x1="140.75"
                    x2="44.315"
                    y1="68.062"
                    y2="394.32"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint15_linear_0_34175"
                    x1="258.532"
                    x2="238.776"
                    y1="127.365"
                    y2="324.495"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint16_linear_0_34175"
                    x1="215.273"
                    x2="270.056"
                    y1="281.873"
                    y2="281.873"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint17_linear_0_34175"
                    x1="294.583"
                    x2="198.147"
                    y1="106.852"
                    y2="433.109"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint18_linear_0_34175"
                    x1="208.317"
                    x2="188.561"
                    y1="122.335"
                    y2="319.464"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint19_linear_0_34175"
                    x1="169.563"
                    x2="149.807"
                    y1="118.451"
                    y2="315.581"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint20_linear_0_34175"
                    x1="19.435"
                    x2="-0.322"
                    y1="103.406"
                    y2="300.536"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint21_linear_0_34175"
                    x1="201.793"
                    x2="216.505"
                    y1="153.33"
                    y2="226.531"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint22_linear_0_34175"
                    x1="344.051"
                    x2="294.953"
                    y1="44.879"
                    y2="86.133"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint23_linear_0_34175"
                    x1="251.021"
                    x2="224.802"
                    y1="308.212"
                    y2="308.212"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint24_linear_0_34175"
                    x1="251.021"
                    x2="224.802"
                    y1="312.918"
                    y2="312.918"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint25_linear_0_34175"
                    x1="296.148"
                    x2="283.871"
                    y1="308.275"
                    y2="308.275"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint26_linear_0_34175"
                    x1="296.148"
                    x2="284.236"
                    y1="313.848"
                    y2="313.848"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint27_linear_0_34175"
                    x1="878.202"
                    x2="829.104"
                    y1="-373.808"
                    y2="-332.554"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint28_linear_0_34175"
                    x1="229.073"
                    x2="225.813"
                    y1="134.522"
                    y2="114.385"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint29_linear_0_34175"
                    x1="218.509"
                    x2="239.64"
                    y1="101.882"
                    y2="118.077"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint30_linear_0_34175"
                    x1="234.422"
                    x2="215.308"
                    y1="89.94"
                    y2="114.594"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint31_linear_0_34175"
                    x1="221.134"
                    x2="242.261"
                    y1="98.458"
                    y2="114.653"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint32_linear_0_34175"
                    x1="215.301"
                    x2="205.255"
                    y1="-99.048"
                    y2="-144.038"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint33_linear_0_34175"
                    x1="880.887"
                    x2="831.789"
                    y1="-370.618"
                    y2="-329.364"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint34_linear_0_34175"
                    x1="181.937"
                    x2="196.648"
                    y1="151.725"
                    y2="224.93"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint35_linear_0_34175"
                    x1="243.035"
                    x2="275.472"
                    y1="68.34"
                    y2="21.181"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint36_linear_0_34175"
                    x1="246.199"
                    x2="293.537"
                    y1="300.445"
                    y2="149.701"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint37_linear_0_34175"
                    x1="232.388"
                    x2="259.497"
                    y1="197.423"
                    y2="232.537"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#5AB6FF"></stop>
                    <stop offset="1" stopColor="#2F68E3"></stop>
                </linearGradient>
                <linearGradient
                    id="paint38_linear_0_34175"
                    x1="256.284"
                    x2="229.313"
                    y1="102.132"
                    y2="227.206"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint39_linear_0_34175"
                    x1="228.113"
                    x2="200.451"
                    y1="94.793"
                    y2="223.062"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint40_linear_0_34175"
                    x1="247.024"
                    x2="219.718"
                    y1="99.543"
                    y2="226.157"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint41_linear_0_34175"
                    x1="297.306"
                    x2="269.224"
                    y1="89.707"
                    y2="134.085"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint42_linear_0_34175"
                    x1="183.145"
                    x2="168.52"
                    y1="-1.908"
                    y2="42.045"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint43_linear_0_34175"
                    x1="228.393"
                    x2="349.894"
                    y1="150.086"
                    y2="181.554"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint44_linear_0_34175"
                    x1="266.771"
                    x2="416.34"
                    y1="196.897"
                    y2="225.389"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint45_linear_0_34175"
                    x1="262.327"
                    x2="292.308"
                    y1="180.157"
                    y2="223.535"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <clipPath id="clip0_0_34175">
                    <path fill="#fff" d="M0 0H329.494V315H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default MainImg;
